<template>
  <div class="home">
    <header class="header">
      <h2>科极信息科技（武汉）有限公司</h2>
    </header>
    <el-carousel :interval="4000" height="341px">
      <el-carousel-item>
        <img src="../assets/banner.jpg" alt="" srcset="" class="banner-img" />
      </el-carousel-item>
      <!-- <el-carousel-item>
        <img src="../assets/banner2.png" alt="" srcset="" class="banner-img" />
      </el-carousel-item> -->
    </el-carousel>
    <div class="desc">
      <h2>关于我们</h2>
      <p class="title">
        科极信息科技（武汉）有限公司，成立于2022-12-21，位于湖北省武汉市，是一家以从事信息传输、软件和信息技术服务业为主的企业。
      </p>
      <div>
        <p>公司主营业务包括:</p>
        <ul>
          <li>
            信息系统集成服务,医学研究和试验发展,技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广。
          </li>
          <li>
            代驾服务,商务代理代办服务,租赁服务（不含许可类租赁服务）,机械设备租赁,汽车拖车、求援、清障服务,紧急救援服务。
          </li>
          <li>
            专业保洁、清洗、消毒服务,汽车零部件及配件制造,汽车零配件批发,汽车零配件零售,汽车装饰用品制造,汽车装饰用品销售,喷涂加工,停车场服务。
          </li>
          <li>
            智能车载设备制造,智能车载设备销售,安全系统监控服务,人工智能应用软件开发。
          </li>
        </ul>
      </div>
    </div>
    <div class="footer">
      <div class="content">
        <p>
          地址：湖北省武汉市东湖新技术开发区关南科技工业园现代国际设计城三期9幢23层8号、9号2024133
        </p>
        <p>
          Copyright © 2022-2025 kejiwuhan.com All Rights Reserved.
          <a href="https://beian.miit.gov.cn" target="_blank"
            >鄂ICP备2025097078号</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  // name: "Home"
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.logo {
  margin-top: 50px;
}
.footer {
  width: 100%;
  position: fixed;
  bottom: 0;
  line-height: 20px;
  color: #999;
  background: #4b4b4b;
  a {
    text-decoration: none;
    color: #999;
  }
  .content {
    width: 1040px;
    margin: 0 auto;
    text-align: left;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  width: 1040px;
}
.desc {
  text-align: left;

  margin: 48px auto 0;
  width: 1040px;
  h2 {
    border-left: 4px solid #008858;
    padding-left: 8px;
    line-height: 28px;
  }
  .title {
    background-color: #008858;
    color: #fff;
    padding: 10px;
    margin-top: 20px;
    width: 850px;
    background-image: linear-gradient(to right, #008858 0%, #c6f3d7 100%);
  }
}
.banner-img {
  width: 1040px;
  height: 100%;
}
</style>
